module.exports = __webpack_public_path__ + "img/bg2.e3a0a5ca.png";